'use client'

import React from 'react'
import { Button } from "@/components/ui/button"
import { useRouter } from 'next/navigation'
import playStore from '../../public/images/WebsiteImages/Googleplay.png'
import appStore from '../../public/images/WebsiteImages/AppStore.png'
import Image from 'next/image'
import logo from '../../public/images/WebsiteImages/logo.png'


const Footer = ({isBookADemo=true}) => {
  const router = useRouter();

  const handleDemo = () => {
    router.push("/schedule-demo")
  }
 return(
  <footer className=" bg-[#ebf2f0] px-6">
  <div className="max-w-7xl mx-auto pb-[20px]">   
    <hr className="border-gray-300 mb-12" />
    <div className="grid md:grid-cols-4 gap-8">
      <div>
        <div className="flex items-center text-green-600 font-bold text-2xl mb-4">
        <Image
        src={logo}
        alt="Farminsta Logo"
        width={120}
        height={32}
        className="object-contain"
      
      />
        </div>
        <p className="text-gray-600 mb-4">Join our growing community and experience the transformative power of digital agriculture</p>

        <div className="flex space-x-4">
          <a
            href="https://app.farminsta.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <Image
              src={playStore}
              alt="Get it on Google Play"
              width={120}
              height={40}
              className="h-10 w-auto cursor-pointer"
            />
          </a>


          <a
            href="https://app.farminsta.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block"
          >
            <Image
              src={appStore}
              alt="Download on the App Store"
              width={120}
              height={40}
              className="h-10 w-auto cursor-pointer"
            />
          </a>
        </div>
      </div>
      <div className='ml-20'>
        <h3 className="font-bold mb-4">Navigate</h3>
        <ul className="space-y-2">
          <li><a href="/" className="text-gray-600 hover:text-green-600">Home</a></li>
          <li><a href="/pricing1" className="text-gray-600 hover:text-green-600">Pricing</a></li>
          <li><a href="/influencer" className="text-gray-600 hover:text-green-600">Influencer</a></li>
          {/* <li><a href="/contact-us" className="text-gray-600 hover:text-green-600">Contact Us</a></li> */}
        </ul>
      </div>
      <div className='ml-20'>
        <h3 className="font-bold mb-4">Resources</h3>
        <ul className="space-y-2 ">
        {/* <li><a href="/blog" className="text-gray-600 hover:text-green-600">Blog</a></li> */}
          {/* <li><a href="/faqs" className="text-gray-600 hover:text-green-600">FAQ's</a></li> */}
          <li><a href="/privacy" className="text-gray-600 hover:text-green-600">Privacy Policy</a></li>
          <li><a href="/terms" className="text-gray-600 hover:text-green-600">Terms & Condition</a></li>
          {/* <li><a href="/guides" className="text-gray-600 hover:text-green-600" >Guides</a></li> */}
        </ul>
      </div>
      <div className='ml-20'>
        <h3 className="font-bold mb-4">Channels</h3>
        <ul className="space-y-2">
          <li><a href="https://www.youtube.com/@farminsta12" className="text-gray-600 hover:text-green-600" target="_blank">Youtube</a></li>
          <li><a href="https://www.instagram.com/farminsta_/" className="text-gray-600 hover:text-green-600" target="_blank">Instagram</a></li>
          <li><a href="https://www.facebook.com/farminsta" className="text-gray-600 hover:text-green-600" target="_blank">Facebook</a></li>
          <li><a href="https://www.linkedin.com/company/farminsta" className="text-gray-600 hover:text-green-600" target="_blank">LinkedIn</a></li>
        </ul>
      </div>
    </div>
  </div>
</footer>
 )
}

export default Footer